import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';

const WeekSelector = ({ selectedWeek, setSelectedWeek }) => {
  const { t } = useTranslation();
  const [weeks, setWeeks] = useState([]);
  const [lastAllowedWeek, setLastAllowedWeek] = useState(0);

  useEffect(() => {
    const today = new Date();
    const firstMonday = new Date(today.getFullYear(), 0, 1);
    while (firstMonday.getDay() !== 1) {
      firstMonday.setDate(firstMonday.getDate() + 1);
    }

    const tempWeeks = [];
    let monday = new Date(firstMonday);
    let currentWeekNumber = 1;
    let last = 0;

    while (monday.getFullYear() === today.getFullYear()) {
      const startOfWeek = new Date(monday);
      const endOfWeek = new Date(monday);
      endOfWeek.setDate(endOfWeek.getDate() + 6);

      if (today >= startOfWeek) {
        last = currentWeekNumber;
      }
      

      tempWeeks.push({
        weekNumber: currentWeekNumber,
        start: new Date(startOfWeek),
        end: new Date(endOfWeek),
      });

      monday.setDate(monday.getDate() + 7);
      currentWeekNumber++;
    }

    setWeeks(tempWeeks);
    setLastAllowedWeek(last);

    if (selectedWeek === null || selectedWeek === undefined) {
      const prev = last > 1 ? last - 1 : 1;
      setSelectedWeek(prev);
    }
  }, [selectedWeek, setSelectedWeek]);

  const formatDate = (date) => {
    return `${String(date.getDate()).padStart(2, "0")}.${String(date.getMonth() + 1).padStart(2, "0")}`;
  };

  return (
    <div className="col-md-3 mb-3">
      <select
        className="form-select"
        id="week"
        value={selectedWeek || ""}
        onChange={(e) => setSelectedWeek(Number(e.target.value))}
      >
        <option value="" disabled>
          -- {t("selectWeek")} --
        </option>
        {weeks
          .filter(({ weekNumber }) => weekNumber <= lastAllowedWeek)
          .map(({ weekNumber, start, end }) => (
            <option key={weekNumber} value={weekNumber}>
              {t("week")} {weekNumber} ({formatDate(start)} – {formatDate(end)})
            </option>
          ))}
      </select>
    </div>
  );
};

export default WeekSelector;
